import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsPrefix", "onChange", "value", "label", "required", "placeholder", "className", "disabled", "disabledAlpha", "isParameterArea", "disabledModal"];

var _dec, _class;

import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.number.constructor.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Form from '../../wui-form/src';
import FormControl from '../../wui-input/src';
import Modal from '../../wui-modal/src';
import Button from '../../wui-button/src';
import Icon from '../../wui-icon/src';
import Select from '../../wui-select/src';
import { Col, Row } from '../../wui-layout/src';
import InputGroup from "../../wui-input-group/src";
import colors from './colors';
import Input from "../../wui-input/src";
import { WebUI } from "../../wui-core/src/index.js";
var FormItem = Form.FormItem;
var Option = Select.Option;
var propTypes = {
  clsPrefix: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledAlpha: PropTypes.bool,
  autoCalculate: PropTypes.func,
  onChange: PropTypes.func,
  title: PropTypes.string,
  cacelBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
  isParameterArea: PropTypes.bool,
  modalProps: PropTypes.object,
  disabledModal: PropTypes.bool
};
var defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  required: false,
  disabled: false,
  disabledAlpha: false,
  autoCalculate: function autoCalculate() {},
  onChange: function onChange() {},
  title: '取色板',
  cacelBtn: '取消',
  confirmBtn: '确认',
  isParameterArea: true,
  disabledModal: false
};
var initRgb = colors['red'].rgbArr[6] ? "rgb(".concat(colors['red'].rgbArr[6], ")") : '';
var ColorPicker = (_dec = WebUI({
  name: "colorpicker",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ColorPicker, _Component);

  var _super = _createSuper(ColorPicker);

  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.stopPropagation();

      _this.setState({
        displayColorPicker: !_this.state.displayColorPicker
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var _this$cache = _this.cache,
          selectedColor = _this$cache.selectedColor,
          selectedScale = _this$cache.selectedScale,
          selectedRgbValue = _this$cache.selectedRgbValue,
          selectedHexValue = _this$cache.selectedHexValue,
          alpha = _this$cache.alpha;

      _this.setState({
        displayColorPicker: false,
        selectedColor: selectedColor,
        selectedScale: selectedScale,
        selectedRgbValue: selectedRgbValue,
        selectedHexValue: selectedHexValue,
        alpha: alpha
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      var _this$props = _this.props,
          autoCalculate = _this$props.autoCalculate,
          onChange = _this$props.onChange;
      var _this$state = _this.state,
          selectedColor = _this$state.selectedColor,
          selectedScale = _this$state.selectedScale,
          selectedHexValue = _this$state.selectedHexValue,
          alpha = _this$state.alpha;

      var tempRgb = _this.colorHexToRgb(selectedHexValue, alpha);

      var obj = {
        class: "".concat(selectedColor, "-").concat(selectedScale),
        rgba: tempRgb,
        hex: selectedHexValue
      };

      _this.setState({
        formValue: selectedHexValue,
        displayColorPicker: false
      });

      _this.cache = Object.assign(_this.cache, {
        selectedColor: selectedColor,
        selectedScale: selectedScale,
        selectedRgbValue: tempRgb,
        selectedHexValue: selectedHexValue,
        formValue: selectedHexValue,
        alpha: alpha
      });

      if (autoCalculate) {
        var result = _this.calcHoverAndActive(selectedColor, selectedScale, selectedHexValue);

        autoCalculate(result);
      }

      if (onChange) {
        onChange(obj);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calcHoverAndActive", function (selectedColor, selectedScale, selectedHexValue) {
      var obj = {};
      var selectedRgbArr = colors[selectedColor] ? colors[selectedColor].rgbArr : '';
      var selectedScaleArr = colors[selectedColor] ? colors[selectedColor].scale : '';
      var index = selectedScaleArr.indexOf(selectedScale);
      var lighter = "",
          darker = "";

      if (index === 0) {
        lighter = "";
        darker = "rgb(".concat(selectedRgbArr[index + 1], ")");
        obj.lighter = lighter;
        obj.darker = darker;
      } else if (index === selectedRgbArr.length - 1) {
        lighter = "rgb(".concat(selectedRgbArr[index - 1], ")");
        darker = "";
        obj.lighter = lighter;
        obj.darker = darker;
      } else if (index > 0 && index < selectedRgbArr.length - 1) {
        lighter = "rgb(".concat(selectedRgbArr[index - 1], ")");
        darker = "rgb(".concat(selectedRgbArr[index + 1], ")");
        obj.lighter = lighter;
        obj.darker = darker;
      }

      obj.clor = selectedHexValue;
      return obj;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (value) {
      var selectedRgb = "rgb(".concat(colors[value].rgbArr[6], ")") || '';

      var selectedHex = _this.colorRGBtoHex(selectedRgb);

      _this.setState({
        selectedColor: value,
        selectedScale: "600",
        selectedRgbValue: selectedRgb,
        selectedHexValue: selectedHex,
        alpha: 100
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectScale", function (value, e) {
      var rgb = e.currentTarget.currentStyle.backgroundColor;

      var hex = _this.colorRGBtoHex(rgb);

      _this.setState({
        selectedScale: value,
        selectedRgbValue: rgb,
        selectedHexValue: hex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function () {
      var clsPrefix = _this.props.clsPrefix;
      var opts = [];

      for (var prop in colors) {
        var item = colors[prop];
        opts.push( /*#__PURE__*/React.createElement(Option, {
          key: item.key,
          value: item.key,
          className: "".concat(clsPrefix, "-select-option clearfix")
        }, /*#__PURE__*/React.createElement("div", {
          className: "option-overview bg-".concat(item.key, "-600")
        }, " "), /*#__PURE__*/React.createElement("span", null, " ", item.name, " ")));
      }

      return opts;
    });

    _defineProperty(_assertThisInitialized(_this), "renderColorPlate", function (selectedColor) {
      var _this$state2 = _this.state,
          selectedScale = _this$state2.selectedScale,
          selectedRgbValue = _this$state2.selectedRgbValue;
      var list = [];
      var color = {};

      if (colors[selectedColor]) {
        color = colors[selectedColor];
      }

      var iconClass = _this.isDark(selectedRgbValue) ? 'dark-contrast' : 'light-contrast';
      color.scale.map(function (item) {
        list.push( /*#__PURE__*/React.createElement("li", {
          key: item.key,
          className: "bg-".concat(color.key, "-").concat(item),
          onClick: function onClick(e) {
            return _this.handleSelectScale(item, e);
          }
        }, selectedScale === item ? /*#__PURE__*/React.createElement(Icon, {
          type: "uf-correct-2",
          className: iconClass
        }) : ""));
      });
      return list;
    });

    _defineProperty(_assertThisInitialized(_this), "isDark", function (rgbColor) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var aColor;

      if (/^(rgb|RGB)/.test(rgbColor)) {
        aColor = rgbColor.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
      }

      var r = aColor[0],
          g = aColor[1],
          b = aColor[2];

      if (r * 0.299 + g * 0.578 + b * 0.114 >= 192) {
        //浅色
        return false;
      } else {
        //深色
        return true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var onChange = _this.props.onChange;

      var tempRgb = _this.colorHexToRgb(value);

      var obj = {
        class: "",
        rgba: tempRgb,
        hex: value
      };

      if (onChange) {
        onChange(obj);
      }

      _this.setState({
        formValue: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAlphaChange", function (value) {
      var reg = /^(?:0|[1-9][0-9]?|100)$/;

      if (value == '' || reg.test(value)) {
        _this.setState({
          alpha: value
        });
      }
    });

    var initValue = "";
    var initHex = "";

    if ('value' in props) {
      initValue = props.value;
      initHex = _this.colorRGBtoHex(initRgb);
    }

    _this.state = {
      displayColorPicker: false,
      selectedColor: "red",
      selectedScale: "600",
      selectedRgbValue: initRgb,
      selectedHexValue: initHex,
      formValue: initValue,
      alpha: 100
    };
    _this.input = {};
    _this.cache = {
      selectedColor: "red",
      selectedScale: "600",
      selectedRgbValue: initRgb,
      selectedHexValue: initHex,
      formValue: initValue,
      alpha: 100
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          formValue: nextProps.value
        });
      }
    } // 打开色板

  }, {
    key: "colorHexToRgb",
    value: // 把16进制颜色转换为RGB颜色
    function colorHexToRgb(color, alpha) {
      var sColor = color;
      sColor = sColor.toLowerCase(); //十六进制颜色值的正则表达式

      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/; // 如果是16进制颜色

      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";

          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }

          sColor = sColorNew;
        } //处理六位的颜色值


        var sColorChange = [];

        for (var _i = 1; _i < 7; _i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(_i, _i + 2)));
        }

        if (alpha) {
          sColorChange.push(alpha);
        }

        return "rgba(" + sColorChange.join(",") + ")";
      }

      return sColor;
    } // 把RGB颜色转换为16进制颜色

  }, {
    key: "colorRGBtoHex",
    value: function colorRGBtoHex(color) {
      var that = color;
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

      if (/^(rgb|RGB)/.test(that)) {
        var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        var strHex = "#";

        for (var i = 0; i < aColor.length; i++) {
          var hex = Number(aColor[i]).toString(16);

          if (hex.length < 2) {
            hex = '0' + hex;
          }

          strHex += hex;
        }

        if (strHex.length !== 7) {
          strHex = that;
        }

        return strHex;
      } else if (reg.test(that)) {
        var aNum = that.replace(/#/, "").split("");

        if (aNum.length === 6) {
          return that;
        } else if (aNum.length === 3) {
          var numHex = "#";

          for (var _i2 = 0; _i2 < aNum.length; _i2 += 1) {
            numHex += aNum[_i2] + aNum[_i2];
          }

          return numHex;
        }
      }

      return that;
    }
    /**
     * 根据RGB值判断 深色与浅色
     * @param rgbColor rgb色值
     * @return
     */

  }, {
    key: "render",
    value: function render() {
      var self = this;

      var _this$props2 = this.props,
          clsPrefix = _this$props2.clsPrefix,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          label = _this$props2.label,
          required = _this$props2.required,
          placeholder = _this$props2.placeholder,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          disabledAlpha = _this$props2.disabledAlpha,
          isParameterArea = _this$props2.isParameterArea,
          disabledModal = _this$props2.disabledModal,
          others = _objectWithoutProperties(_this$props2, _excluded);

      var _this$state3 = this.state,
          selectedColor = _this$state3.selectedColor,
          selectedScale = _this$state3.selectedScale,
          selectedRgbValue = _this$state3.selectedRgbValue,
          selectedHexValue = _this$state3.selectedHexValue,
          formValue = _this$state3.formValue,
          alpha = _this$state3.alpha;
      var _this$props$form = this.props.form,
          getFieldProps = _this$props$form.getFieldProps,
          getFieldError = _this$props$form.getFieldError;
      var rules = required ? [{
        required: true,
        message: '请输入十六进制色值！'
      }, {
        pattern: /^#[0-9a-fA-F]{6}$/,
        message: '色值格式不正确'
      }] : null;

      HTMLElement.prototype.__defineGetter__("currentStyle", function () {
        return this.ownerDocument.defaultView.getComputedStyle(this, null);
      });

      return /*#__PURE__*/React.createElement("div", {
        className: classnames(clsPrefix, className)
      }, /*#__PURE__*/React.createElement(FormItem, {
        className: "".concat(clsPrefix, "-form")
      }, label ? /*#__PURE__*/React.createElement("label", {
        className: "".concat(clsPrefix, "-label")
      }, required ? /*#__PURE__*/React.createElement(Icon, {
        type: "uf-mi",
        className: "mast"
      }) : "", label) : '', /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormControl, {
        disabled: disabled,
        placeholder: placeholder,
        value: formValue,
        onChange: this.handleChange
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: formValue,
          zIndex: 9
        },
        className: "".concat(clsPrefix, "-form-color-demo ").concat(disabledModal ? "disabled" : ''),
        onClick: !disabled && !disabledModal ? this.handleClick : null
      }))), /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, getFieldError('hexadecimal')), /*#__PURE__*/React.createElement(Modal, _extends({
        width: isParameterArea ? '600' : '350',
        className: "".concat(clsPrefix, "-modal"),
        show: this.state.displayColorPicker,
        onHide: this.handleClose,
        backdropClosable: false
      }, this.props.modalProps), /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, this.props.title)), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-header")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-color-preview")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-color-preview-demo bg-").concat(selectedColor, "-600")
      })), /*#__PURE__*/React.createElement(Select, {
        defaultValue: selectedColor,
        style: {
          width: 200
        },
        onChange: this.handleSelectChange
      }, this.renderOption())), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-content")
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: 14,
        xs: 14,
        sm: 14,
        style: isParameterArea ? {} : {
          width: '100%',
          marginLeft: '10.5px'
        },
        className: "col-7"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "".concat(clsPrefix, "-panel-color-plate clearfix")
      }, this.renderColorPlate(selectedColor))), isParameterArea && /*#__PURE__*/React.createElement(Col, {
        md: 10,
        xs: 10,
        sm: 10,
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-color-info")
      }, /*#__PURE__*/React.createElement("div", {
        className: "transparent-bg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "selected-color bg-".concat(selectedColor, "-").concat(selectedScale),
        style: {
          opacity: alpha / 100
        }
      })), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
        className: "".concat(clsPrefix, "-label")
      }, "Class\uFF1A"), "".concat(selectedColor, "-").concat(selectedScale)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
        className: "".concat(clsPrefix, "-label")
      }, "RGB\uFF1A"), "".concat(selectedRgbValue)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
        className: "".concat(clsPrefix, "-label")
      }, "HEX\uFF1A"), "".concat(selectedHexValue)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
        className: "".concat(clsPrefix, "-label")
      }, "Alpha"), /*#__PURE__*/React.createElement(Input, {
        size: "sm",
        value: alpha,
        onChange: this.handleAlphaChange,
        disabled: disabledAlpha,
        suffix: "%"
      })))))))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.handleClose,
        colors: "secondary",
        style: {
          marginRight: 8
        }
      }, this.props.cacelBtn), /*#__PURE__*/React.createElement(Button, {
        onClick: this.submit,
        colors: "primary"
      }, this.props.confirmBtn))));
    }
  }]);

  return ColorPicker;
}(Component)) || _class);
;
ColorPicker.propTypes = propTypes;
export default Form.createForm()(ColorPicker);


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-colorpicker/src/ColorPicker.js